import React from 'react';
import { ChipContainer, StyledCaret, StyledCheckmark } from './Chip.styles';
import COLORS from '../../styles/emotion/colors';

type TwoLinesProps = { twoLines?: false; width?: never } | { twoLines: true; width: string };

export type ChipProps = React.HTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  /** state where blue border and blue background */
  selected?: boolean;
  /** state where blue border and white background; overrides selected state */
  active?: boolean;
  disabled?: boolean;
  /** onClick callback */
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  showCheckmark?: boolean;
  /** can be used as label */
  htmlFor?: string;
  /** displays caret to the right of text */
  withCaret?: boolean;
} & TwoLinesProps;

/**
 * Uncontrolled chip component
 * Implement logic to control separately
 */
const Chip = React.forwardRef<HTMLButtonElement, ChipProps>(
  (
    { children, onClick, showCheckmark, selected, active, disabled, twoLines, withCaret, ...args },
    ref
  ) => {
    const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
      if (onClick) {
        onClick(e);
      }
    };

    return (
      <ChipContainer
        onClick={handleClick}
        selected={selected}
        active={active}
        ref={ref}
        disabled={disabled}
        twoLines={twoLines}
        withCaret={withCaret}
        // add data-* attributes so styled component props can be targeted
        data-selected={selected}
        data-active={active}
        {...args}
      >
        {showCheckmark && selected && <StyledCheckmark />}
        {children}
        {withCaret && (
          <StyledCaret
            selected={selected}
            width={14}
            height={16}
            fill={disabled ? COLORS.ALTO : COLORS.BLUE}
          />
        )}
      </ChipContainer>
    );
  }
);

export default Chip;
